export enum VerificationSettingEchoEnum {
  SETTING = "SETTING",
  DOCKING = "DOCKING",
}
